// import "@swivl/swivl-chat-typescript/build/bundle.css";
import { QuestInterface } from "@swivl-mono/types";
import * as React from "react";

import "./TestQuestView.scss";

// import { Config } from 'apps/chat/src/Config/Config';
// import SwivlChat from 'apps/chat/src/SwivlChat';

interface Props {
  selectedQuest: QuestInterface;
}
interface State {
  isShowingHoover: boolean;
  botVariables: any;
  variablesSearch: string;
}

export default class TestQuestView extends React.Component<Props, State> {
  /*
  constructor(props:Props) {
    super(props)
    this.saveTestVariablesRunHoover = this.saveTestVariablesRunHoover.bind(this);
    this.varUpdated = this.varUpdated.bind(this);
    this.clearVariables = this.clearVariables.bind(this)
    this.state = {
      variablesSearch:"",
      isShowingHoover:false,
      testBotUser:undefined,
      botVariables:VarsModel.variableOptions(true)
    }
  }

  componentDidMount() {
    var query = new Parse.Query(BotUser);
    query.equalTo("bot", BotModel.state.bot);
    query.equalTo("isTestBotUser", true);
    query.first().then((testUser)  => {
      if (testUser) {
        this.setState({testBotUser: testUser});
      } else {
        warn("No test user");
      }
    }).catch((err) => {
      warn("COULDN'T FIND/CREATE ANY TEST USERS FOR THIS BOT", err);
    });
  }

  saveTestVariablesRunHoover() {
    var nodes = this.props.selectedQuest.data;
    var startNode = Object.keys(nodes)[0];

    const qNodePointer =  {
      questSlug:  this.props.selectedQuest.slug,
      nodeId: startNode
    }


    this.state.testBotUser.set("QNodePointer",  qNodePointer);

    // this.state.testBotUser.set("currentNodeId", startNode);

    // this.state.testBotUser.set("currentQuest", this.props.selectedQuest);
    this.state.testBotUser.save();
    this.setState({isShowingHoover: true});
  }

  varUpdated(e) {
    var userVariableValue = e.target.value;
    var userVariableKey = e.target.name;
    let testBotUser = this.state.testBotUser;
    let userVars = testBotUser.get("userVariables") || {}
    userVars[userVariableKey] = userVariableValue;
    testBotUser.set("userVariables", userVars);
    this.setState({testBotUser: testBotUser});
  }

  clearVariables() {
    let testBotUser = this.state.testBotUser;
    testBotUser.set("userVariables", {});

    this.setState({testBotUser:testBotUser})
  }


  render() {
    const {isShowingHoover, testBotUser, botVariables,variablesSearch}  = this.state;

    let botUserId, userToken;

    let variables = [];

    if (!isShowingHoover) {
      if (botVariables) {
        const userVars = (testBotUser) ? testBotUser.get("userVariables") || {} : {}
        const filteredBorVariables = variablesSearch.length > 0 ? botVariables.filter((item) => { return item.name.toLowerCase().indexOf(variablesSearch.toLowerCase()) > -1 }) : botVariables;

        variables = filteredBorVariables.map((item) => {
          const id = item.id;
          const value = userVars[item.id] || ""
          return  <div key={id}>
                    <label>{item.name}</label>
                  </div>
         })

      }


      return <div className="TestQuestView">
        <header>
                 <span className="setupVarInstructions">Edit variables to test different cases</span>
                 <div className="buttons">

       <a onClick={this.clearVariables}>Clear</a>
       {testBotUser ? <a className="testButton" onClick={this.saveTestVariablesRunHoover} >Test</a> :<a className="testButton"  ><Spinner /></a>  }
      </div>
       </header>
       <div style={{padding:"0 10px"}}>
      </div>
       <hr />

<div className="variables">



       {variables}
     </div>
        </div>;

    } else {

    if (this.state.testBotUser) { //need to load test bot user before setting these vars:
      botUserId = this.state.testBotUser.id;
      userToken = this.state.testBotUser.get("token");
    }
    const auth = {botId: BotModel.state.bot.id,botUserId:botUserId, type: SenderOrRecipientType.BotUser,token:userToken}; warn("Using Auth!");

    var config = DefaultEmbedConfig({botId:BotModel.state.bot.id})
    config.startOnQuest = this.props.selectedQuest.slug;


        return <div className="TestQuestView">

<SwivlChat
                              config={config}
                              auth={auth}
                              generateCSS={true}
                              isOpen={true}
                              server={Config.SOCKET_HOSTNAME}
                              canTakeOver={false}
                              parentControlsStart={false}
                              isConversationTakenOver={false}
                              isMobile={false}
                              commandCallback={(command)=>{ warn("Got Command!",command); }} />




      </div>



  }
}
*/
}
